// import * as Sentry from '@sentry/node';
import { local } from 'wix-storage';
import { loadChatDB } from 'backend/chat';
import { insertMsg } from 'backend/chat';
import { loadCaseDB } from 'backend/case';
import { registerLawyer } from 'backend/auth';
import wixLocation from 'wix-location';
import moment from 'moment';
import wixWindow from 'wix-window';
import { getLawyers } from 'backend/lawyer';
import { getLawyer } from 'backend/lawyer';
import { getStatus } from 'backend/status';
import { getLabels } from 'backend/label';
import { registerCase } from 'backend/case';
import { getInstances } from 'backend/file';
import { uploadFile } from 'backend/file';
import { getFileTypes } from 'backend/file';
import { loadCases } from 'backend/case';
import { registerEvent } from 'backend/event';
import { getFiles } from 'backend/file';
import { searchFiles } from 'backend/file';
import { getEventFiles } from 'backend/file';
import { loadEvents } from 'backend/event';
import { loadAllEvents } from 'backend/event';
import { load2notes } from 'backend/event';
import { loadSingleEvent } from 'backend/event';
import { archiveLawyer } from 'backend/auth';
import { getSingleLawyer } from 'backend/lawyer';
import { changeCase } from 'backend/case';
import { searchCases } from 'backend/case';
import { finishCase } from 'backend/case';
import { registerNote } from 'backend/note';
import { subscriber } from 'backend/pusher';
import { loadEventNotes } from 'backend/note';
import { changeVisibility } from 'backend/note';
import { deleteNote } from 'backend/note';
import { updateFile } from 'backend/file';
import { getSingleFile } from 'backend/file';


// Sentry.init({ dsn: 'https://3e2e9ed9f65f40c3ae5cf9ce30dac94d@o395498.ingest.sentry.io/5248702' });
let caseID = 0;
let lawyerID = 0;
let caseUserID = 0;
let user = JSON.parse(local.getItem('user'));
let avatar = '';
if (user) {
    avatar = 'https://pravo.deystvie.org/avatars/avatar\-' + user.ID + '.png?now=' + moment(new Date()).format("DD-MM-YYYY-mm-ss");
}
let adminAvatar = 'https://pravo.deystvie.org/avatars/avatar\-1.png?now=' + moment(new Date()).format("DD-MM-YYYY-mm-ss");
let currentPage = 1;
let totalPages = 1;
let typeSortAsc = true;
let nameSortAsc = true;
let fileSizeSortAsc = true;
let dateSortAsc = true;
let eventID;
let pastEventID;
let loading = true;
let updateEvent = 0;
let updateNote = 0;
let fileID = 0;
let searchStatus = 0;
let initcase = 0;
let key = '';
let pickedLawyerID = 0;
let pickedLabel = [];
local.setItem('lawyerToEdit', '');

$w.onReady(async function () {
    console.log('user', user);
    if (!user) {
        wixLocation.to('/lp-login');
    } else {
        $w('#imageToReplace').src = avatar;
        $w('#imageToReplace').expand();
        $w('#hello').text = 'Здравей, ' + user.Name;

        // load pusher
        // subscriber('my-channel');
        // var channel = pusher.subscribe('my-channel');
        // channel.bind('my-event', function(data) {
        //   console.log(JSON.stringify(data));
        // });

        // subscriber('my-channel').then(channel => {
        //     channel.bind('my-event', function(data) {
        //         console.log(JSON.stringify(data));
        //     });
        // })
        // .catch(error => {
        //     console.log('error 69');
        //  console.log(error);
        // });

        $w('#cases').style.backgroundColor = '#A8A8A8';

        let statusDropdown = $w('#statusDropdown');
        let lawyerDropdown = $w('#lawyerDropdown');
        let selectionTags = $w('#selectionTags');

        await getStatus().then(response => {
            let options = [];
            response.forEach(status => {
                let option = {
                    value: status.ID,
                    label: status.Name
                };
                console.log('опт: ', status)
                options.push(option);

            });
            statusDropdown.options = options;
        });

        await getLawyers().then(response => {
            console.log('getLawyers', response);
            if (response) {
                let options = [];
                response.forEach(lawyer => {
                    let fullname = lawyer.Name + ' ' + lawyer.Last;
                    let option = {
                        value: lawyer.ID,
                        label: fullname
                    };
                    console.log('adv: ', fullname)
                    options.push(option);

                });
                lawyerDropdown.options = options;
            }
        });

        await getLabels().then(response => {
            console.log('label: ', response);
            let options = [];
            response.forEach(label => {

                let option = {
                    value: label.ID,
                    label: label.Name
                };
                options.push(option);
                console.log(label.Name);

            });
            selectionTags.options = options;
        });

        // load cases
        $w('#casesRepeater').data = [];
        await loadCases(Number(user.ID), currentPage).then(response => {
            console.log('loadCases', response);
            $w('#casesRepeater').data = response;
            $w('#pagination').totalPages = Math.ceil(Number(response[0].Total) / 8);
        }).catch(error => console.log(error));

        console.log('lblL ', selectionTags.options);

        console.log('pg ', totalPages, currentPage);
        $w('#pagination').totalPages = totalPages;
        $w('#pagination').currentPage = currentPage;

        loadCase(Number(user.ID));

        switch (Number(user.Level)) {
        case 1:
            $w('#addFileFromChat').expand();
            break;
        case 2:
            $w('#myLaywer').label = 'МОЯТ КЛИЕНТ';
            break;
        case 3:
            $w('#cases').label = 'ДЕЛА';
            $w('#myLaywer').label = 'АДВОКАТИ';
            break;
        default:
            break;
        }

        // loadCases(Number(user.ID), currentPage).then(response => {
        //  $w('#casesRepeater').data = response;
        // }).catch(error => console.log(error));

        // reload chat every 3 seconds
        setInterval(function () {
            loadChat(user.ID, caseID);
        }, 3000);

        // hide loading box

        $w('#navigation').expand();
        $w('#Menu').expand();
        $w('#chatbox').expand();
        $w('#initCase').expand();

        if (user.Level === '3') {

            await getLawyers().then(response => {
            let options = [];
            response.forEach(lawyer => {
            let option = {
                value: lawyer.ID,
                label: lawyer.Name +  ' ' + lawyer.Last
            };
            options.push(option);
            });
            $w('#chooseLawyer').options = options;
            });

            await getLabels().then(response => {
            let options = [];
            response.forEach(label => {
            let option = {
                value: label.ID,
                label: label.Name
            };
            options.push(option);
            });
            $w('#chooseLabel').options = options;
            });

            $w('#casesData').expand();
            $w('#searchOptions').expand();
            $w('#searchCases').expand();
            $w('#chooseLawyer').expand();
            $w('#chooseLabel').expand();
            $w('#clearSearch').expand();

    }

        $w('#LoadingStrip').collapse();


    }
});

function btnSelected(button) {
    $w('#cases').style.backgroundColor = '#FFFFFF';
    $w('#files').style.backgroundColor = '#FFFFFF';
    $w('#calendars').style.backgroundColor = '#FFFFFF';
    $w('#myLaywer').style.backgroundColor = '#FFFFFF';

    $w(button).style.backgroundColor = '#A8A8A8';
}

function getCaseData(caseDB) {
    $w('#casesData').collapse();
    $w('#initCase').collapse();

    let status = Number(caseDB.StatusID) === 1 ? 'Активен' : 'Неактивен'
    const date = moment(caseDB.Created);
    let dateTime = date.format("DD.MM.YYYY");

    $w('#caseDate').text = dateTime;
    if (caseDB.Name) {
        $w('#newCaseName').text = caseDB.Name;
    } else {
        $w('#newCaseName').text = 'Няма данни.';
    }

    if (status) {
        $w('#newCaseStatus').text = status;
    } else {
        $w('#newCaseName').text = 'Няма данни.';
    }

    if (caseDB.InitText) {
        $w('#caseInfo').text = caseDB.InitText;
    } else {
        $w('#caseInfo').text = 'Няма данни.';
    }

    if (caseDB.ShortDesc) {
        $w('#shortDesc').text = caseDB.ShortDesc;
    } else {
        $w('#shortDesc').text = 'Няма данни.';
    }

    if (caseDB.GoalDesc) {
        $w('#goalDesc').text = caseDB.GoalDesc;
    } else {
        $w('#goalDesc').text = 'Няма данни.';
    }

    if (caseDB.Labels) {
        $w('#labels').text = caseDB.Labels.toString(); // for now
    } else {
        $w('#labels').text = 'Няма данни.';
    }

    load2notes(caseID).then(response => {
        console.log('load2notes: ', response);
        if (response.ok) {
            $w('#noFiles').collapse();
            $w('#fileRepeater').expand();
            $w('#fileRepeater').data = response;
        } else {
            $w('#noFiles').expand();
            $w('#fileRepeater').collapse();
        }
    }).catch(error => console.log(error));

    if (Number(user.Level) > 1 && Number(caseDB.StatusID) === 1) {
        $w('#finishCaseBtn').expand();
        $w('#currentCaseID').text = caseDB.ID;
    } else {
         $w('#finishCaseBtn').collapse();
    }

    $w('#case').expand();
}

function loadCase(userID) {
    loadCaseDB(userID).then(caseDB => {
            console.log('loadCaseDB', caseDB, 'user', user);
            const date = moment(caseDB.Created);
            let dateTime = date.format("DD.MM.YYYY");
            caseID = caseDB.ID;
            lawyerID = Number(caseDB.LawyerID);
            caseUserID = Number(caseDB.UserID);

            // load chat
            caseID = caseDB.ID;
            loadChat(userID, caseID);

            // if laywer or admin and no registered case
            if ((Number(caseDB.LawyerID) === 0 || caseDB.ShortDesc === '' || caseDB.GoalDesc === '') && Number(user.Level) > 1) {
                getInitCaseData(caseDB);
            } else {
                getCaseData(caseDB);
            }

            // if user have no laywer disable menu
            if (Number(caseDB.LawyerID) === 0 && Number(user.Level) === 1) {

                $w('#files').disable();
                $w('#calendars').disable();
                $w('#myLaywer').disable();
            }
        })
        .catch(error => {
            console.log(error);
        });
}

function loadChat(userID) {
    // console.log('userID, caseID', userID, caseID);
    loadChatDB(userID, caseID).then(messages => {
            // console.log('messages', messages);
            if (messages) {
                // console.log('yes', messages);
                $w('#chatRepeater').data = messages;
            } else {
                // console.log('no chat');
                // let noMsg = [{
                //     "ID": "1",
                //     "Message": "Все още няма изпратени съобщения за това дело. Когато това стане те ще се появят тук.",
                //     "UserID": "1",
                //     "CaseID": caseID,
                //     "FileID": "0",
                //     "_id": "1",
                //     "Date": moment(new Date()).format("DD-MM-YYYY HH:mm:ss"),
                //     "Level": "1"
                // },];
                // $w('#chatRepeater').data = noMsg;
            }
        })
        .catch(error => {
            console.log(error);
        });
}

function sendMsg(msg) {
    if (msg.replace(/\s/g, '').length) {
        insertMsg(msg, user.ID, caseID).then(messages => {
                $w('#chat').value = '';
                $w('#chat').placeholder = 'Съобщението беше изпратено';
                $w('#chatRepeater').data = messages;
                $w('#chatboxLeftChars').collapse();
                $w('#chatboxLeftChars').text = 'Остава 220 символа';
            })
            .catch(error => {
                console.log(error);
            });
    } else {
        $w('#chat').value = '';
    }
}

function openNoteContainer(selEventID) {
    $w('#EventNotHolderBox').collapse();
    updateNote = 0;
    $w('#eventNoteText').value = '';
    $w('#eventNoteText').resetValidityIndication();

    if (Number(user.Level) < 2) {
        $w('#eventNoteText').hide();
        $w('#visibleNote').hide();
        $w('#visibleText').hide();
        $w('#EventNotSaveBtn').hide();
        $w('#NoteIsVisible').hide();
        $w('#NoteIsNotVisible').hide();
        $w('#DeleteEventNote').hide();
        $w('#EditEventNote').hide();
    } else {
        $w('#eventNoteText').show();
        $w('#visibleNote').show();
        $w('#visibleText').show();
        $w('#EventNotSaveBtn').show();
    }

    loadEventNotes(selEventID).then(response => {
        if (response) {
            console.log('all notes', response);
            $w('#EventNoteRepeater').expand();
            $w('#noNotes').collapse();
            $w('#EventNoteRepeater').data = response;
        } else {
            $w('#EventNoteRepeater').collapse();
            $w('#noNotes').expand();
        }
    }).catch(error => console.log(error));

    $w('#eventNoteError').collapse();
    $w('#EventNotHolderBox').expand();
}

export function logout_click(event) {
    local.setItem("user", '');
    wixLocation.to('/lp-login');
}

export function chat_keyPress(event) {
    let maxChars = 1088;
    let charCount = $w('#chat').value.length + 1;
    if (charCount + 220 >= maxChars) {
        $w('#chatboxLeftChars').text = 'остават ' + (maxChars - charCount + 1);
        $w('#chatboxLeftChars').expand();
    }

    if (event.key === 'Enter') {
        let message = $w('#chat').value;
        sendMsg(message);
    }
}

export function sendBtn_click(event) {
    let message = $w('#chat').value;
    sendMsg(message);
}

export function chatRepeater_itemReady($item, itemData, index) {
    console.log('itemData', itemData);
    const date = moment(itemData.Created);
    let dateTime = date.format("DD-MM-YYYY HH:mm:ss");
    let uniqueTime = date.format("DD-MM-YYYY-HH-mm-ss");
    let laywerAvatar = 'https://pravo.deystvie.org/avatars/avatar\-' + lawyerID + '.png?now=' + uniqueTime;
    let userAvatar = 'https://pravo.deystvie.org/avatars/avatar\-' + caseUserID + '.png?now=' + uniqueTime;
    $item('#userAvatar').src = userAvatar;
    if (lawyerID) {
        $item('#laywerAvatar').src = laywerAvatar;
    }
    $item('#adminAvatar').src = adminAvatar;

    if (Number(itemData.Level) === 1) { // user
        $item('#lawyerChatBox').collapse();
        $item('#adminChatBox').collapse();
        $item('#userText').text = itemData.Message;
        $item('#userChatTime').text = dateTime;
        if (Number(itemData.FileID) !== 0) {
            $item("#DownloadFileUser").target = "_blank";
            getSingleFile(itemData._id, caseID).then(response => {
                console.log(response);
                $item('#DownloadFileUser').link = response.FilePath;
                $item('#DownloadFileUser').expand();
            }).catch(error => {
                console.log(error);
            });
            console.log('FileChat ItemData: ', itemData);
        }
    } else if (Number(itemData.Level) === 2) { // lawyer
        $item('#userChatBox').collapse();
        $item('#adminChatBox').collapse();
        $item('#lawyerText').text = itemData.Message;
        $item('#lawyerChatTime').text = dateTime;
    } else if (Number(itemData.Level) === 3 || (Number(user.Level) !== 3 && Number(itemData.System) !== 1)) { // admin
        $item('#userChatBox').collapse();
        $item('#lawyerChatBox').collapse();
        $item('#adminChatText').text = itemData.Message;
        $item('#adminChatTime').text = dateTime;
    } else {
        $item('#userChatBox').collapse();
        $item('#lawyerChatBox').collapse();
        $item('#adminChatBox').collapse();
    }

    $w('#chatRepeater').expand();
}

export function hello_click(event) {
    wixWindow.openLightbox('Profile-Popup');
}

export async function registerLawyerBtn_click(event) {
    $w('#registerLawyerBtn').collapse();
    $w('#loadingRegisterLawyer').expand();

    let lawyerToEdit = local.getItem('lawyerToEdit');

    let name = $w('#firstName').value;
    let last = $w('#lastName').value;
    let email = $w('#email').value;
    let city = $w('#city').value;
    let phone = $w('#phone').value;

    if (!($w('#error').collapsed)) {
        $w('#error').collapse();
    }

    if (name && last && email && city && phone) {
        await registerLawyer(name, last, email, city, phone, lawyerToEdit).then(response => {
                if (response.error) {
                    throw new Error(response.error.message);
                }
                $w('#registerLawyer').collapse();
                $w('#firstName').value = '';
                $w('#lastName').value = '';
                $w('#email').value = '';
                $w('#city').value = '';
                $w('#phone').value = '';
                local.setItem('lawyerToEdit', '');
                $w('#lawyerRepeater').data = [];

                getLawyers().then(response2 => {
                    $w('#lawyerRepeater').data = response2;
                    let options = [];
                    response2.forEach(lawyer => {
                        let fullname = lawyer.Name + ' ' + lawyer.Last;
                        let option = {
                            value: lawyer.ID,
                            label: fullname
                        };
                        console.log('adv: ', fullname);
                        options.push(option);

                    });
                    $w('#lawyerDropdown').options = options;
                });
                $w('#loadingRegisterLawyer').collapse();
                $w('#registerLawyerBtn').expand();
                $w('#lawyerRepeater').expand();
            })
            .catch(error => console.log(error.message));
    } else {
        $w('#error').text = 'Моля попълнете всички полета!';
        $w('#error').expand();
    }
}

export function EditLawerInfoBtn_click(event) {
    let lawyerId = Number(event.context.itemId);
    local.setItem('lawyerToEdit', lawyerId);
    getSingleLawyer(lawyerId).then(response => {
        if (response.error) {
            throw new Error(response.error.message);
        }
        $w('#firstName').value = response.Name;
        $w('#lastName').value = response.Last;
        $w('#email').value = response.Email;
        $w('#city').value = response.City;
        $w('#phone').value = response.Phone;

        $w('#registerLawyer').expand();
    }).catch(error => {
        console.log(error);
    });
}

export async function cases_click(event) {
    $w('#innerLoading').expand();
    $w('#files').disable();
    $w('#calendars').disable();
    $w('#myLaywer').disable();
    $w('#UserFiles').collapse();
    $w('#UserEvents').collapse();
    $w('#case').collapse();
    $w('#laweyrs').collapse();
    $w('#mylawyeruser').collapse();
    $w('#initCase').collapse();
    $w('#casesData').expand();
    $w('#DeleteConfirmationBox').collapse();
    $w('#registerLawyer').collapse();
    $w('#CreateEventHolderBox').collapse();
    $w('#EventNotHolderBox').collapse();

    await loadCaseDB(user.ID).then(caseDB => {
        console.log('caseDB', caseDB);
        // if user have no laywer disable menu
        if (Number(caseDB.LawyerID) !== 0 || Number(user.Level) > 2) {
            console.log('enable menu');
            btnSelected('#cases');
            $w('#files').enable();
            $w('#calendars').enable();
            $w('#myLaywer').enable();
        }
    });

    $w('#innerLoading').collapse();

}

export async function files_click(event) {
    btnSelected('#files');
    $w('#innerLoading').expand();

    $w('#UserFiles').expand();
    $w('#UserEvents').collapse();
    $w('#case').collapse();
    $w('#laweyrs').collapse();
    $w('#initCase').collapse();
    $w('#mylawyeruser').collapse();
    $w('#casesData').collapse();
    $w('#DeleteConfirmationBox').collapse();
    $w('#registerLawyer').collapse();
    $w('#CreateEventHolderBox').collapse();
    $w('#EventNotHolderBox').collapse();

    if (Number(user.Level) < 2) {
        $w('#AddFileBtn').hide();
    }

    await getFiles(caseID).then(response => {
        if (response) {
            $w('#noAllFiles').collapse();
            $w('#allFilesRepeater').expand();
            $w('#allFilesRepeater').data = response;
        } else {
            $w('#allFilesRepeater').collapse();
            $w('#noAllFiles').expand();
        }
    }).catch(error => console.log(error));

    $w('#innerLoading').collapse();
}

export async function calendars_click(event) {
    btnSelected('#calendars');
    $w('#innerLoading').expand();

    $w('#UserEvents').expand();
    $w('#UserFiles').collapse();
    $w('#case').collapse();
    $w('#laweyrs').collapse();
    $w('#mylawyeruser').collapse();
    $w('#initCase').collapse();
    $w('#casesData').collapse();
    $w('#DeleteConfirmationBox').collapse();
    $w('#registerLawyer').collapse();
    $w('#CreateEventHolderBox').collapse();
    $w('#EventNotHolderBox').collapse();

    if (Number(user.Level) < 2) {
        $w('#AddEventBtn').hide();
        $w('#EditNote').hide();
    }

    await loadAllEvents(caseID).then(response => {
        console.log('All Events: ', response);
        if (response.new) {
            $w('#noUpcomingEvents').collapse();
            $w('#UpcomingEvents').expand();
            $w('#UpcomingEvents').data = response.new;
        } else {
            $w('#noUpcomingEvents').expand();
            $w('#UpcomingEvents').collapse();
        }

        if (response.old) {
            $w('#noPastEvents').collapse();
            $w('#PastEventsRepeate').expand();
            $w('#PastEventsRepeate').data = response.old
        } else {
            $w('#noPastEvents').expand();
            $w('#PastEventsRepeate').collapse();
        }
    }).catch(error => console.log(error));

    $w('#innerLoading').collapse();
}

export async function myLaywer_click(event) {
    btnSelected('#myLaywer');
    $w('#innerLoading').expand();
    $w('#UserEvents').collapse();
    $w('#UserFiles').collapse();
    $w('#case').collapse();
    $w('#initCase').collapse();
    $w('#casesData').collapse();
    $w('#DeleteConfirmationBox').collapse();
    $w('#registerLawyer').collapse();
    $w('#CreateEventHolderBox').collapse();
    $w('#EventNotHolderBox').collapse();

    if (Number(user.Level) !== 3) {
        await getLawyer(caseID).then(lawyer => {
            let lawyerAvatar = 'https://pravo.deystvie.org/avatars/avatar\-' + lawyer.ID + '.png?now=' + moment(new Date()).format("DD-MM-YYYY-mm-ss");
            console.log(lawyerAvatar);
            $w('#LawyerPictureUser').src = lawyerAvatar;
            $w('#LawyerName').text = 'адв. ' + lawyer.Name + ' ' + lawyer.Last;
            $w('#LawyerPhone').text = lawyer.Phone;
            $w('#LawyerInfo').text = lawyer.LawyerInfo;
        });
        $w('#mylawyeruser').expand();
    } else {
        await getLawyers().then(response => {
            console.log("getLawyers", response);
            if (response) {
                $w('#lawyerRepeater').data = response;
            } else {
                $w('#lawyerRepeater').collapse();
                // TODO expand
            }
        });
        $w('#laweyrs').expand();
    }
    
    $w('#innerLoading').collapse();
}

export function lawyerRepeater_itemReady($item, itemData, index) {
    console.log(itemData);
    $item('#lawyerFullname').text = itemData.Name + " " + itemData.Last;
    $item('#lawyerEmail').text = itemData.Email;
    $item('#lawyerPhone').text = itemData.Phone;
    $item('#lawyerCity').text = itemData.City;
    $item('#activeCases').html = '<span style="color: rgb(50, 65, 88); font-size: 14px, font-family: wfont_84be43_1d7bd8e8e65a41debb625f4275ae9a26,wf_1d7bd8e8e65a41debb625f427,orig_roboto_light;">';
    $item('#finishedCases').text = '';
    $item('#avatar').src = 'https://pravo.deystvie.org/avatars/avatar\-' + itemData.ID + '.png?now=' + moment(new Date()).format("DD-MM-YYYY-mm-ss");

    if (itemData.activeCases) {
        itemData.activeCases.forEach(activeCase => {
            $item('#activeCases').html += 'Случай #' + activeCase.ID + '<br>';
            console.log('Active Case: ', activeCase);
        });
    } else {
        $item('#activeCases').text = 'Няма данни.';
    }
    if (itemData.finishedCases) {
        itemData.finishedCases.forEach(finishedCase => {
            $item('#finishedCases').html += 'Случай #' + finishedCase.ID + '<br>';
            console.log('finished Case: ', finishedCase);
        });
    } else {
        $item('#finishedCases').text = 'Няма данни.';
    }
    $item('#activeCases').html += '</span>';

    itemData.loginDetails.forEach(login => {
        const date = moment(login.Date);
        let dateTime = date.format("DD.MM.YYYY г. HH:mm:ss");
        $item('#lastLogin').text = dateTime;
        console.log('login: ', login);
    })

    $item('#hideText').text = itemData.ID;

    console.log('delete link', $item('#DeleteLawyerBtn').link)
    console.log('items: ', itemData);
}

export async function registerCase_click_1(event) {
    let caseName = $w('#caseName').value;
    let description = $w('#caseDescription').value;
    let status = $w('#statusDropdown').value;
    let lawyer = $w('#lawyerDropdown').value;
    let caseGoal = $w('#caseGoal').value;
    let labels = $w('#selectionTags').value;
    let checkbox = $w('#caseCheckbox').checked;
    let selectedCase = caseID; //For now

    console.log('Case Name: ', caseName);
    console.log('Desc: ', description);
    console.log('Status: ', status);
    console.log('Lawyer: ', lawyer);
    console.log('Case Goal: ', caseGoal);
    console.log('Labels: ', labels);
    console.log('Checkbox: ', checkbox);
    console.log('CaseID: ', selectedCase);

    if (caseName && status && lawyer) {
        await registerCase(selectedCase, labels, caseName, lawyer, description, caseGoal, status).then(response => {
            console.log(response);
            loadCase(user.ID);
            const date = moment(response.Created);
            let dateTime = date.format("DD.MM.YYYY");
            $w('#initCase').collapse();
            $w('#case').expand();

            $w('#caseDate').text = dateTime;
            $w('#newCaseName').text = response.Name;
            $w('#newCaseStatus').text = 'Активен' //for now
            $w('#caseInfo').text = response.InitText;
            $w('#shortDesc').text = response.ShortDesc;
            $w('#goalDesc').text = response.GoalDesc;
            $w('#labels').text = response.labels.toString();
            console.log('Response: ', response);
        }).catch(error => console.log(error));

        $w('#casesRepeater').data = [];
        loadCases(Number(user.ID), currentPage).then(response => {
            console.log('loadCases', response);
            $w('#casesRepeater').data = response;
            $w('#pagination').totalPages = Math.ceil(Number(response[0].Total) / 8);
        }).catch(error => console.log(error));
    }
}

export function AddLawyerBtn_click(event) {
    $w('#registerLawyer').expand();
}

export function closeRegisterLawyer_click(event) {
    $w('#registerLawyer').collapse();
}

export async function DeleteLawyerBtn_click(event) {
    if (!($w('#DeleteConfirmationBox').collapsed)) {
        $w('#DeleteConfirmationBox').collapse();
    }

    if (!($w('#lawyerError').collapsed)) {
        $w('#lawyerError').collapse();
    }

    let lawyerID2 = event.target.parent.children[3].text;
    local.setItem('lawyerToDelete', lawyerID2);
    await getSingleLawyer(lawyerID2).then(response => {
        console.log('names', response);
        $w('#lawyerNames').text = response[0].Name + ' ' + response[0].Last;
    })
    $w('#DeleteConfirmationBox').expand();

    console.log('lawyer id ', lawyerID2);
}

export function closeDeleteLawyer_click(event) {
    $w('#DeleteConfirmationBox').collapse();
}

export function UploadFile_change(event) {
    if ($w("#UploadFile").value.length > 0) { // user chose a file
        let fileName = $w("#UploadFile").value[0].name;

        console.log("Uploading " + fileName);
        console.log(fileName);
        console.log(fileName.endsWith('.jpg'));
        if (fileName.endsWith('tif') || fileName.endsWith('tiff') || fileName.endsWith('pdf') ||
            fileName.endsWith('doc') || fileName.endsWith('docx') || fileName.endsWith('xls') ||
            fileName.endsWith('xlsx') || fileName.endsWith('csv') || fileName.endsWith('TIF') ||
            fileName.endsWith('TIFF') || fileName.endsWith('PDF') ||
            fileName.endsWith('DOC') || fileName.endsWith('DOCX') || fileName.endsWith('XLS') ||
            fileName.endsWith('XLSX') || fileName.endsWith('CSV')) {

            $w("#UploadFile").startUpload()
                .then((uploadedFile) => {
                    console.log(uploadedFile.mediaId);
                    let fileUrl = 'https://9a3ab710-e9a6-4ad4-89bc-9c1491237b13.usrfiles.com/ugd/' + uploadedFile.mediaId;
                    local.setItem('fileUrl', fileUrl);
                    local.setItem('fileName', uploadedFile.title);
                    console.log('FileUrl: ', fileUrl);
                    $w('#SaveFileBtn').expand();
                }).catch((uploadError) => {
                    console.log("File upload error: " + uploadError.errorCode);
                    console.log(uploadError.errorDescription);
                });
        } else {
            $w('#fileError').text = 'Не се поддържа такъв тип файл!';
            $w('#fileError').expand();
        }
    } else { // user clicked button but didn't chose a file
        console.log("Please choose a file to upload.")
    }
}

export async function updateFile_click(event) {
    $w('#SaveFileBtn').expand();
    $w('#fileTitle').text = 'РЕДАКТИРАЙ ФАЙЛ';
    fileID = Number(event.target.parent.children[4].text);
    let instances = $w('#InstanceDropdown');
    let fileTypes = $w('#FileTypeDropdown');
    let eventConnection = $w('#EventConnection');

    await getInstances().then(response => {
        let options = [];
        console.log('res : ', response);
        response.forEach(instance => {
            let option = {
                value: instance.ID,
                label: instance.Name
            };
            console.log('instance: ', instance)
            options.push(option);

        });
        instances.options = options;
    });

    await getFileTypes().then(response => {
        let options = [];
        console.log('res : ', response);
        response.forEach(fileType => {
            let option = {
                value: fileType.ID,
                label: fileType.Name
            };
            console.log('fileType: ', fileType)
            options.push(option);

        });
        fileTypes.options = options;
    });

    await loadEvents(caseID).then(response => {
        if (response) {
            let options = [];
            console.log('events : ', response);
            response.forEach(events => {
                let option = {
                    value: events.ID,
                    label: events.Name
                };
                options.push(option);
            });
            eventConnection.options = options;
        } else {
            eventConnection.options = [{
                value: 'Няма данни',
                label: 'Няма данни'
            }];
        }
    });

    await getSingleFile(fileID, caseID).then(response => {
        if (response) {
            console.log('file response ', response);
            $w('#FileTypeDropdown').value = response.TypeID;

            if (response.EventID) {
                $w('#EventConnection').value = response.Event.ID;
                console.log('event ', $w('#EventConnection'));
            }

            $w('#InstanceDropdown').value = response.CountID;

            $w('#note').value = response.Text;

            Number(response.Visible) === 1 ? $w('#SwitchNoteFile').checked = true : $w('#SwitchNoteFile').checked = false;
        }
    })

    $w('#pictureOrFile').hide();
    $w('#UploadFile').hide();
    $w('#uploadImage').collapse();
    console.log('target', fileID);
    $w('#AddFileHolderBox').expand();
}

async function getAllCases(userID) {
    $w('#innerLoading').expand();
    $w('#case').collapse();
    $w('#initCase').collapse();

    currentPage = Number($w('#pagination').currentPage);
    $w('#casesRepeater').data = [];
    await loadCases(Number(userID), currentPage).then(response => {
        console.log('All Cases: ', response, 'Current Page', currentPage);
        $w('#casesRepeater').data = response;
        $w('#pagination').totalPages = Math.ceil(Number(response[0].Total) / 8);
        console.log(response[0].Total);
    }).catch(error => console.log(error));

    $w('#casesData').expand();
    $w('#innerLoading').collapse();
}

export function AllCasesBtn_click(event) {
    getAllCases(user.ID);
}

export async function AddFileBtn_click(event) {
    let instances = $w('#InstanceDropdown');
    let fileTypes = $w('#FileTypeDropdown');
    let eventConnection = $w('#EventConnection');
    $w('#fileTitle').text = 'ДОБАВИ ФАЙЛ';
    console.log(instances.options);

    $w('#InstanceDropdown').value = '';
    $w('#InstanceDropdown').resetValidityIndication();
    $w('#FileTypeDropdown').value = '';
    $w('#FileTypeDropdown').resetValidityIndication();
    $w('#EventConnection').value = '';
    $w('#EventConnection').resetValidityIndication();
    $w('#note').value = '';
    $w('#note').resetValidityIndication();
    $w('#SwitchNoteFile').checked = true;
    $w('#pictureOrFile').show();
    $w('#UploadFile').show();
    $w('#UploadFile').expand();
    $w('#pictureOrFile').value = 'file';

    await getInstances().then(response => {
        let options = [];
        console.log('res : ', response);
        response.forEach(instance => {
            let option = {
                value: instance.ID,
                label: instance.Name
            };
            console.log('instance: ', instance)
            options.push(option);

        });
        instances.options = options;
    });

    await getFileTypes().then(response => {
        let options = [];
        console.log('res : ', response);
        response.forEach(fileType => {
            let option = {
                value: fileType.ID,
                label: fileType.Name
            };
            console.log('fileType: ', fileType)
            options.push(option);

        });
        fileTypes.options = options;
    });

    await loadEvents(caseID).then(response => {
        if (response) {
            let options = [];
            console.log('events : ', response);
            response.forEach(events => {
                let option = {
                    value: events.ID,
                    label: events.Name
                };
                options.push(option);
            });
            eventConnection.options = options;
        } else {
            eventConnection.options = [{
                value: 'Няма данни',
                label: 'Няма данни'
            }];
        }
    });

    $w('#AddFileHolderBox').expand();
}

export function closeAddFile_click(event) {
    $w('#AddFileHolderBox').collapse();
}

export async function SaveFileBtn_click(event) {
    $w('#SaveFileBtn').collapse();
    $w('#loadingFile').expand();

    let fileType = Number($w('#FileTypeDropdown').value);
    let selectedEvent = Number($w('#EventConnection').value);
    let instance = Number($w('#InstanceDropdown').value);
    let note = $w('#note').value;
    let visible = $w('#SwitchNoteFile').checked;
    let file = local.getItem('fileUrl');
    let name = local.getItem('fileName');

    if (local.getItem('imageUrl')) {
        file = local.getItem('imageUrl');
        name = local.getItem('imageName');
    }

    eventID = Number($w('#EventConnection').value)

    if (visible) {
        visible = 1;
    } else {
        visible = 0;
    }

    console.log('CaseID: ', caseID);

    if ($w('#fileTitle').text === 'ДОБАВИ ФАЙЛ') {
        await uploadFile(caseID, file, name, fileType, eventID, instance, note, visible).then(response => {
            console.log('saving');
            console.log(response);
        }).catch(error => {
            $w('#loadingFile').collapse();
            $w('#SaveFileBtn').expand();
            console.log(error)
        });
    } else if (($w('#fileTitle').text === 'РЕДАКТИРАЙ ФАЙЛ') && fileID !== 0) {
        await updateFile(fileID, fileType, eventID, instance, note, visible).then(response => {
            if (response) {
                console.log(response);
            }
        }).catch(error => {
            $w('#loadingFile').collapse();
            $w('#SaveFileBtn').expand();
            console.log(error);
        });
    }
    loadChat(user.ID, caseID);

    $w('#allFilesRepeater').data = [];

    await getFiles(caseID).then(response => {
        if (response) {
            $w('#noAllFiles').collapse();
            $w('#allFilesRepeater').expand();
            $w('#allFilesRepeater').data = response;
        } else {
            $w('#allFilesRepeater').collapse();
            $w('#noAllFiles').expand();
        }

    }).catch(error => console.log(error));

    $w('#loadingFile').collapse();
    $w('#SaveFileBtn').expand();
    $w('#AddFileHolderBox').collapse();

    if (local.getItem('fileUrl')) {
        local.removeItem('fileUrl');
        local.removeItem('fileName');
    } else {
        local.removeItem('imageUrl');
        local.removeItem('imageName');
    }

    $w('#FileTypeDropdown').value = '';
    $w('#FileTypeDropdown').resetValidityIndication();
    $w('#EventConnection').value = '';
    $w('#EventConnection').resetValidityIndication()
    $w('#InstanceDropdown').value = '';
    $w('#InstanceDropdown').resetValidityIndication();
    $w('#note').value = '';
    $w('#note').resetValidityIndication();
    $w('#SwitchNoteFile').checked = true;
}

export function AddEventBtn_click(event) {
    let today = new Date();
    updateEvent = 0;
    console.log(today);
    $w('#CreateEventHolderBox').collapse();
    $w('#EventDateInput').value = today;
    $w('#EventTimeInput').value = today.getHours() + ":" + today.getMinutes();
    $w('#EventNameInput').value = '';
    $w('#EventNameInput').resetValidityIndication();
    $w('#EventAddressInput').value = '';
    $w('#EventAddressInput').resetValidityIndication();
    $w('#eventAddonTitle').text = 'СЪЗДАЙ СЪБИТИЕ';
    $w('#SwitchEventClientAction').checked = true;
    $w('#checkboxGroup1').value = ['1 hour before', '1 day before']
    $w('#CreateEventHolderBox').expand();
}

export function CloseCreateEventBox_click(event) {
    $w('#CreateEventHolderBox').collapse();
}

export async function saveEvent_click(event) {
    $w('#loadingEvent').expand();
    $w('#saveEvent').collapse();

    let date = moment($w('#EventDateInput').value);
    let time = $w('#EventTimeInput').value;
    let name = $w('#EventNameInput').value;
    let address = $w('#EventAddressInput').value;
    let clientAction = $w('#SwitchEventClientAction').checked;
    let reminder = $w('#checkboxGroup1').value;

    if (clientAction) {
        clientAction = 1;
    } else {
        clientAction = 0;
    }

    const formatedDate = date.format('YYYY-MM-DD');
    let dateTime = moment(formatedDate + ' ' + time);
    const formatedDateTime = dateTime.format('YYYY-MM-DD HH:mm:ss');

    console.log('Date: ', formatedDate);
    console.log('DateTime: ', formatedDateTime);

    await registerEvent(caseID, reminder, formatedDateTime, name, address, clientAction, updateEvent).then(response => {
        console.log(response);
    }).catch(error => {
        $w('#loadingEvent').collapse();
        $w('#saveEvent').expand();

        console.log(error)
    });

    $w('#UpcomingEvents').data = [];

    await loadAllEvents(caseID).then(response => {
        console.log('All Events: ', response);
        $w('#UpcomingEvents').data = response.new;

        if (response.old) {
            $w('#PastEventsRepeate').data = response.old;
            $w('#noPastEvents').collapse();
        } else {
            $w('#PastEventsRepeate').collapse();
            $w('#noPastEvents').expand();
        }

    }).catch(error => console.log(error));

    $w('#loadingEvent').collapse();
    $w('#saveEvent').expand();

    $w('#CreateEventHolderBox').collapse();
    $w('#EventTimeInput').resetValidityIndication()
    $w('#EventNameInput').value = '';
    $w('#EventNameInput').resetValidityIndication();
    $w('#EventAddressInput').value = '';
    $w('#EventAddressInput').resetValidityIndication();

}

export function casesRepeater_itemReady($item, itemData, index) {
    console.log('Case Item :', itemData, 'CaseID: ', caseID);
    $item('#repeatedCaseName').text = 'Случай #' + itemData.ID;
    let date = moment(itemData.Created);
    let formatedDate = date.format('DD.MM.YYYY');
    $item('#repeatedCaseDate').text = formatedDate;
    $item('#repeatedCaseUser').text = itemData.UName;

    if (Number(itemData.StatusID) === 1) {
        $item('#starCase').collapse();
        $item('#resumeCase').expand();
        $item('#pauseCase').collapse();
    } else if (Number(itemData.StatusID) === 2) {
        $item('#starCase').collapse();
        $item('#resumeCase').collapse();
        $item('#pauseCase').expand();
    }

    if (Number(itemData.LawyerID) === 0) {
        $item('#starCase').expand();
        $item('#resumeCase').collapse();
        $item('#pauseCase').collapse();
        $item('#repeatedLawyerCase').text = 'Няма добавен адвокат.';
    } else {
        getLawyer(Number(itemData.ID)).then(response => {
            if (response) {
                $item('#repeatedLawyerCase').text = response.Name + ' ' + response.Last;
            } else {
                $item('#repeatedLawyerCase').text = 'Няма добавен адвокат.';
            }
        }).catch(error => {
            console.log(error);
            $item('#repeatedLawyerCase').text = 'Няма добавен адвокат.';
        });
    }

    if (Number(itemData.ID) === Number(caseID)) {
        $item('#eventBox').style.backgroundColor = '#CACFD5';
    } else {
        $item('#eventBox').style.backgroundColor = '#FFFFFF';
    }
}

export function pagination1_click(event) {
    let page = Number($w('#pagination').currentPage);
    loadCases(user.ID, page).then(response => {
        $w('#casesRepeater').data = response;
    }).catch(error => console.log(error));
}

export function fileRepeater_itemReady($item, itemData, index) {
    let date = moment(itemData.Date);
    let formatedDate = date.format('DD.MM.YYYY');
    console.log('Visible OR not ', itemData);
    let text = '';
    $item('#nameOfFile').html = '<span style="color: rgb(50, 65, 88); font-size: 14px, font-family: wfont_84be43_1d7bd8e8e65a41debb625f4275ae9a26,wf_1d7bd8e8e65a41debb625f427,orig_roboto_light;">';
    if (itemData.Note) {
        $item('#eventIcon').expand();
        $item('#nameOfFile').html += itemData.Name;
    } else {
        $item('#fileIcon').expand();
        $item('#nameOfFile').html += '<a href="' + itemData.FilePath + '" target="_blank">' + itemData.Name + '</a>';
    }
    $item('#nameOfFile').html += '';

    $item('#fileDate').text = formatedDate;

    if (Number(itemData.Visible) === 1 && itemData.Text) {
        $item('#noteText').text = itemData.Text;
    } else {
        $item('#noteText').text = 'Няма добавена бележка.'
    }
}

export function UpcomingEvents_itemReady($item, itemData, index) {
    let date = moment(itemData.Date);
    let formatedDate = date.format('DD.MM.YY');
    let formatedTime = date.format('HH:mm');
    let now = moment()._d;

    console.log('Event ID: ', itemData.ID);
    // console.log('Now: ', now);

    let daysLeft = Math.ceil(date.diff(now, 'days'));
    console.log('daysLeft: ', daysLeft)

    $item('#EventDate').text = formatedDate;
    $item('#EventTime').text = formatedTime;
    $item('#EventName').text = itemData.Name;
    $item('#EventLocation').text = itemData.Address;
    $item('#eventID').text = itemData.ID;

    let day = Number(formatedDate.split('.')[0]);
    let strNow = now + '';
    let currentDay = Number(strNow.split(' ')[2]);

    console.log('Day: ', day);
    console.log('CurrentDat: ', currentDay);

    if (Number(daysLeft) === 0) {
        if (day - currentDay === 1) {
            $item('#DaysCountdown').text = '1';
            $item('#days').text = 'ден';
        } else {
            $item('#DaysCountdown').text = 'Днес';
            $item('#days').hide();
        }
    } else {
        $item('#DaysCountdown').text = daysLeft + '';

        if (daysLeft === 1) {
            $item('#days').text = 'ден';
        }
    }
}

export function PastEventsRepeate_itemReady($item, itemData, index) {
    let date = moment(itemData.Date);
    let formatedDate = date.format('DD.MM.YY');
    let formatedTime = date.format('HH:mm');

    $item('#pastEventDate').text = formatedDate;
    $item('#PastEventTime').text = formatedTime;
    $item('#PastEventName').text = itemData.Name;
    $item('#PastEventPlace').text = itemData.Address;
    $item('#pastEventID').text = itemData.ID;
}

export function allFilesRepeater_itemReady($item, itemData, index) {
    $w('#searchFiles').expand();

    if (Number(user.Level) === 1) {
        $item('#updateFile').collapse();
    }
    console.log('All Files Item', itemData);
    $item('#FileNameText').text = itemData.File;

    $item('#fileID').text = itemData.ID;
    let fileName = $item('#FileNameText').text;
    $item('#FileNameText').html = '<a href="https://pravo.deystvie.org/cases/' + caseID + '/' + fileName + '" target="_blank">' + fileName + '</a>';

    let date = moment(itemData.Date);
    let formatedDate = date.format('DD.MM.YYYY г. HH:mm');

    if (itemData.Text && (Number(itemData.Visible) === 1 || Number(user.Level) > 1)) {
        $item('#FileNotesText').text = itemData.Text;
    } else {
        $item('#FileNotesText').text = 'Няма добавена бележка';
    }

    $item('#FileSizeText').text = (Number(itemData.FileSize) * 0.000001).toFixed(3) + ' МБ';
    $item('#FileDateText').text = formatedDate;

    getFileTypes().then(response => {
        console.log('type ', response);

        response.forEach(type => {
            if (Number(type.ID) === Number(itemData.TypeID)) {
                $item('#fileType').text = type.Name;
            }
        });

    }).catch(error => console.log(error))
}

export async function deleteInput_keyPress(event) {
    if (event.key === 'Enter') {
        if (!($w('#lawyerError').collapsed)) {
            $w('#lawyerError').collapse();
        }

        let input = $w('#deleteInput').value;
        console.log('inputValue: ', input);
        if (input === 'изтрий') {
            let lawyerID2 = Number(local.getItem('lawyerToDelete'));
            console.log('lawyerIdToDelete', lawyerID2)
            await archiveLawyer(lawyerID2).then(response => {
                if (response.error) {
                    throw new Error(response.error.message);
                }

                $w('#DeleteConfirmationBox').collapse();
            }).catch(error => {
                switch (error.message) {
                case 'LAYWER_HAS_ACTIVE_CASE':
                    $w('#lawyerError').expand();
                    $w('#lawyerError').text = 'Не можете да изтриете адвокат с активно дело.'
                    break;
                case 'USER_NOT_LAYWER':
                    $w('#lawyerError').expand();
                    $w('#lawyerError').text = 'Потребителя, който се опитвате да изтриете не е адвокат.'
                    break;
                default:
                    break;
                }
            });

            await getLawyers().then(response => {
                $w('#lawyerRepeater').data = response;
            }).catch(error => console.log(error));
            local.removeItem('lawyerToDelete');
        } else {
            $w('#lawyerError').expand();
            $w('#lawyerError').text = 'Въведете думата \"изтрий\", за да изтриете адвоката.'
        }
    }
}

export function uploadImage_change(event) {
    if ($w("#uploadImage").value.length > 0) { // user chose a file
        let fileName = $w("#uploadImage").value[0].name;

        console.log("Uploading " + fileName);
        if (fileName.endsWith('.png') || fileName.endsWith('.jpg') || fileName.endsWith('.jpeg') || fileName.endsWith('.PNG') || fileName.endsWith('.JPG') || fileName.endsWith('.JPEG')) {
            $w("#uploadImage").startUpload()
                .then((uploadedFile) => {
                    console.log(uploadedFile.mediaId);
                    let fileUrl = 'https://static.wixstatic.com/media/' + uploadedFile.mediaId;
                    local.setItem('imageUrl', fileUrl);
                    local.setItem('imageName', uploadedFile.title);
                    console.log('Image: ', fileUrl);
                    $w('#SaveFileBtn').expand();
                }).catch((uploadError) => {
                    console.log("File upload error: " + uploadError.errorCode);
                    console.log(uploadError.errorDescription);
                });
        } else {
            $w('#fileError').text = 'Не се поддържа такъв тип файл!';
            $w('#fileError').expand();
        }
    } else { // user clicked button but didn't chose a file
        console.log("Please choose a file to upload.")
    }
}

export async function eventBox_click(event) {
    let targetID = Number(event.context.itemId);
    console.log(targetID, 'id ', Number(user.ID), 'case id: ', caseID);
    caseID = Number(targetID);
    await changeCase(Number(user.ID), caseID).then(response => {
        console.log('Change Case: ', response);
        caseUserID = Number(response.UserID);
        // loadChat(user.ID, caseID);
        // loadCase(user.ID);
        // if laywer or admin and no registered case
        if ((Number(response.LawyerID) === 0 || response.ShortDesc === '' || response.GoalDesc === '') && Number(user.Level) > 1) {
            console.log('getInitCaseData');
            getInitCaseData(response);
        } else {
            console.log('getCaseData');
            getCaseData(response);
        }
    });
}

function getCaseBox() {
    loadCaseDB(Number(user.ID)).then(response => {
        console.log('loadCaseDB', response, 'initcase', (Number(response.LawyerID) === 0 || response.ShortDesc === '' || response.GoalDesc === ''), Number(user.Level) > 1);
        if ((Number(response.LawyerID) === 0 || response.ShortDesc === '' || response.GoalDesc === '') && Number(user.Level) > 1) {
            $w('#casesData').collapse();
            const date = moment(response.Created);
            let dateTime = date.format("DD.MM.YYYY");
            $w('#initCaseText').text = response.InitText;
            $w('#initCaseDate').text = dateTime;
            $w('#caseID').text = 'Заявление #' + response.ID;

            if (response.Name) {
                $w('#caseName').value = response.Name;
            }

            if (response.StatusID) {
                $w('#statusDropdown').value = response.StatusID;
            }

            if (response.LawyerID) {
                $w('#lawyerDropdown').value = response.LawyerID;
            }

            if (response.Labels) {
                $w('#selectionTags').value = response.Labels;
            }

            if (response.ShortDesc) {
                $w('#caseDescription').value = response.ShortDesc;
            }

            if (response.GoalDesc) {
                $w('#caseGoal').value = response.GoalDesc;
            }



            if (Number(user.Level) === 2) {
                $w('#caseName').disable();
                $w('#statusDropdown').disable();
                $w('#lawyerDropdown').disable();;
            }
            $w('#initCase').expand();
        } else {
            $w('#casesData').collapse();
            $w('#case').expand();
        }
    });
}

function getInitCaseData(response) {
    console.log('getInitCaseData', response);

    const date = moment(response.Created);
    let dateTime = date.format("DD.MM.YYYY");
    $w('#casesData').collapse();
    $w('#case').collapse();

    $w('#usernameField').text = response.UName;
    $w('#phoneField').text = response.Phone;
    $w('#emailField').text = response.Email;
    $w('#cityField').text = response.City;
    $w('#initCaseText').text = response.InitText;
    $w('#initCaseDate').text = dateTime;
    $w('#caseID').text = 'Заявление #' + response.ID;

    if (response.Name) {
        $w('#caseName').value = response.Name;
    }

    if (response.StatusID) {
        $w('#statusDropdown').value = response.StatusID;
    }

    if (response.LawyerID) {
         $w('#lawyerDropdown').value = response.LawyerID;
    }

    if (response.Labels) {
        $w('#selectionTags').value = response.Labels;
    }

    if (response.ShortDesc) {
       $w('#caseDescription').value = response.ShortDesc;
    }

    if (response.GoalDesc) {
        $w('#caseGoal').value = response.ShortDesc;
    }

    if (Number(user.Level) === 2) {
        $w('#caseName').disable();
        $w('#statusDropdown').disable();
        $w('#lawyerDropdown').disable();
    }
    $w('#initCase').expand();
}

export function pictureOrFile_change(event) {
    if (Number(event.target.selectedIndex) === 0) {
        $w('#UploadFile').collapse();
        $w('#uploadImage').expand();
    } else {
        $w('#uploadImage').collapse();
        $w('#UploadFile').expand();
    }
}

export function TypeSortBtn_click(event) {

    getFiles(caseID).then(response => {
        if (response) {
            if (typeSortAsc) {
                response.sort((a, b) => a.TypeName.localeCompare(b.TypeName));
                typeSortAsc = false;
            } else {
                response.sort((a, b) => b.TypeName.localeCompare(a.TypeName));
                typeSortAsc = true;
            }

            console.log('Response: ', response);
            $w('#noAllFiles').collapse();
            $w('#allFilesRepeater').data = response;
            $w('#allFilesRepeater').expand();
        }

    }).catch(error => console.log(error));
}

export function NameSortBtn_click(event) {
    getFiles(caseID).then(response => {
        if (response) {
            if (nameSortAsc) {
                response.sort((a, b) => a.File.localeCompare(b.File));
                nameSortAsc = false;
            } else {
                response.sort((a, b) => b.File.localeCompare(a.File));
                nameSortAsc = true;
            }

            console.log('Response: ', response);
            $w('#noAllFiles').collapse();
            $w('#allFilesRepeater').data = response;
            $w('#allFilesRepeater').expand();
        }

    }).catch(error => console.log(error));
}

export function SizeSortBtn_click(event) {
    getFiles(caseID).then(response => {
        if (response) {
            if (fileSizeSortAsc) {
                response.sort((a, b) => a.FileSize - b.FileSize);
                fileSizeSortAsc = false;
            } else {
                response.sort((a, b) => b.FileSize - a.FileSize);
                fileSizeSortAsc = true;
            }

            console.log('Response: ', response);
            $w('#noAllFiles').collapse();
            $w('#allFilesRepeater').data = response;
            $w('#allFilesRepeater').expand();
        }

    }).catch(error => console.log(error));
}

export function DateSortBtn_click(event) {
    getFiles(caseID).then(response => {
        if (response) {
            if (dateSortAsc) {
                response.sort((a, b) => a.Date.localeCompare(b.Date));
                dateSortAsc = false;
            } else {
                response.sort((a, b) => b.Date.localeCompare(a.Date));
                dateSortAsc = true;
            }

            console.log('Response: ', response);
            $w('#noAllFiles').collapse();
            $w('#allFilesRepeater').data = response;
            $w('#allFilesRepeater').expand();
        }

    }).catch(error => console.log(error));
}

export function EventNotes_click(event) {
    eventID = Number(event.context.itemId);

    console.log(eventID, event.context);
    openNoteContainer(eventID);
}

export function PastEventNotes_click(event) {
    eventID = Number(event.context.itemId);
    console.log('id ', Number(event.context.itemId))
    console.log('pastEvent ', eventID, event.context);
    openNoteContainer(eventID);
}

export function closeEventNote_click(event) {
    $w('#EventNoteRepeater').collapse();
    $w('#EventNotHolderBox').collapse();
}

export async function EventNotSaveBtn_click(event) {
    if (Number(user.Level) > 1) {
        if (eventID) {
            let text = $w('#eventNoteText').value;
            let visible = $w('#visibleNote').checked;

            if (visible) {
                visible = 1;
            } else {
                visible = 0;
            }

            if (text) {
                console.log(eventID);
                console.log(text);
                console.log(visible);

                await registerNote(updateNote, eventID, text, visible).then(response => {
                    console.log('Response: ', response);
                    if (response) {
                        $w('#eventNoteText').value = '';
                        $w('#eventNoteText').resetValidityIndication();
                    }
                }).catch(error => console.log(error));

                $w('#EventNoteRepeater').data = [];

                loadEventNotes(eventID).then(response => {
                    if (response) {
                        console.log('all notes', response);
                        $w('#EventNoteRepeater').expand();
                        $w('#noNotes').collapse();
                        $w('#EventNoteRepeater').data = response;
                    } else {
                        $w('#EventNoteRepeater').collapse();
                        $w('#noNotes').expand();
                    }
                }).catch(error => console.log(error));

            } else {
                $w('#eventNoteError').text = 'Няма въведен текст за бележката.';
                $w('#eventNoteError').expand();
            }
        }
    }
}

export async function EditNote_click(event) {
    let selectedEventID = event.context.itemId;
    console.log('selectedID ', selectedEventID);
    loadSingleEvent(selectedEventID).then(response => {
        if (response) {
            updateEvent = selectedEventID;
            const date = moment(response.Date);
            let eventDate = new Date(response.Date.split(' ')[0]);
            let eventTime = date.format('HH:mm');
            let checks = [];
            console.log('response ', response);
            console.log('time ', eventTime);
            console.log('date ', eventDate);
            $w('#eventAddonTitle').text = 'РЕДАКТИРАЙ СЪБИТИЕ';
            $w('#EventDateInput').value = eventDate;
            $w('#EventTimeInput').value = eventTime;
            $w('#EventNameInput').value = response.Name;
            $w('#EventAddressInput').value = response.Address;
            $w('#SwitchEventClientAction').checked = Number(response.UserInteraction) === 1 ? true : false;

            if (Number(response.Remind1hour) === 1) {
                checks.push('1 hour before');
            }

            if (Number(response.Remind1day) === 1) {
                checks.push('1 day before');
            }

            if (Number(response.Remind1week) === 1) {
                checks.push('1 week before');
            }

            $w('#checkboxGroup1').value = checks;

            $w('#CreateEventHolderBox').expand();
            console.log('checked: ', $w('#checkboxGroup1').value);

        } else {}
    }).catch(error => console.log(error));
}

export function EventFiles_click(event) {
    let eventId = Number(event.context.itemId);
    console.log(caseID);
    console.log(eventId);

    getEventFiles(caseID, eventId).then(response => {
        console.log('response: ', response);
        if (response) {
            $w('#allFilesRepeater').data = response;
            $w('#noEventFiles').collapse();
            $w('#UserEvents').collapse();
            $w('#UserFiles').expand();
        } else {
            $w('#noEventFiles').expand();
        }
    }).catch(error => console.log(error));
}

export function PastEventFiles_click(event) {
    let eventId = Number(event.context.itemId);
    console.log(caseID);
    console.log(eventId);

    getEventFiles(caseID, eventId).then(response => {
        console.log('response: ', response);
        if (response) {
            $w('#allFilesRepeater').data = response;
            $w('#noEventFiles').collapse();
            $w('#UserEvents').collapse();
            $w('#UserFiles').expand();
        } else {
            $w('#noEventFiles').expand();
        }
    }).catch(error => console.log(error));
}

export function EditEventNote_click(event) {
    let noteText = event.target.parent.children[6].text;
    let noteID = Number(event.target.parent.parent.children[1].text);
    let eventNoteID = Number(event.target.parent.parent.children[2].text);

    $w('#eventNoteText').value = noteText;

    updateNote = noteID;

    console.log(event.target);
    console.log(noteText);
    console.log(noteID);
}

export function EventNoteRepeater_itemReady($item, itemData, index) {
    let date = moment(itemData.Date);
    let formatedDate = date.format('DD.MM.YYYY');
    let formatedTime = date.format('HH:mm');

    if (Number(itemData.Visible) === 1) {
        $item('#NoteIsVisible').expand();
    } else {
        $item('#NoteIsNotVisible').expand();
    }
    console.log('notes ', itemData);
    $item('#noteID').text = itemData.ID;
    $item('#eventNoteID').text = itemData.EventID;
    $item('#noteDate').text = formatedDate + ' ' + formatedTime;
    $item('#noteTxt').text = itemData.Note;

    $item("#NoteIsNotVisible").onClick((event) => {
        let noteId = event.context.itemId;
        changeVisibility(noteId, 1).then(response => {
            console.log(response);
            if (response) {
                $item("#NoteIsNotVisible").collapse();
                $item('#NoteIsVisible').expand();
            }
        }).catch(error => console.log(error));
    });

    $item("#NoteIsVisible").onClick((event) => {
        let noteId = event.context.itemId;
        changeVisibility(noteId, 0).then(response => {
            console.log(response);
            if (response) {
                $item("#NoteIsNotVisible").expand();
                $item('#NoteIsVisible').collapse();
            }
        }).catch(error => console.log(error));
    });

    $item("#DeleteEventNote").onClick((event) => {
        $item('#DeleteEventNote').collapse();
        $item('#noteSure').expand();
        setTimeout(function () {
            $item('#DeleteEventNote').expand();
            $item('#noteSure').collapse();
        }, 3000);
        $item('#noteSure').onClick((event2) => {
            let noteId = event2.context.itemId;
            deleteNote(noteId).then(response => {
                if (response) {
                    $item('#noteContainer').collapse();
                }
            }).catch(error => console.log(error));
        })

    });
}

export function logoutBtn_click(event) {
    local.removeItem('user');
    wixLocation.to('/lp-login');
}

export function logoutVector_click(event) {
    local.removeItem('user');
    wixLocation.to('/lp-login');
}

export function addFileFromChat_click(event) {
    $w('#FileTypeDropdown').collapse();
    $w('#EventConnection').collapse();
    $w('#InstanceDropdown').collapse();
    $w('#SwitchNoteFile').collapse();
    $w('#TextSwitchNote').collapse();
    $w('#note').collapse();
    $w('#AddFileHolderBox').expand();
}

export function SFileSearchInput_keyPress(event) {
    let search = $w('#SFileSearchInput').value;

    if (search) {
        searchFiles(caseID, search).then(response => {
            console.log('response: ', response);
            if (response) {
                $w('#allFilesRepeater').data = response;
                // $w('#noEventFiles').collapse();
                // $w('#UserEvents').collapse();
                // $w('#UserFiles').expand();
            } else {
                $w('#noEventFiles').expand();
            }
        }).catch(error => console.log(error));
    } else {
        getFiles(caseID).then(response => {
            if (response) {
                $w('#noAllFiles').collapse();
                $w('#allFilesRepeater').data = response;
                $w('#allFilesRepeater').expand();
            }
        }).catch(error => console.log(error));
    }
}

export function searchOptions_click(event) {
    let statusOptions = event.target.value;
    console.log('option click: ', statusOptions);

    statusOptions.forEach(status => {
        switch (status) {
        case 'Active':
            searchStatus = 1;
            $w('#searchOptions').value = ['Active'];
            break;
        case 'Closed':
            searchStatus = 2;
            $w('#searchOptions').value = ['Closed'];
            break;
        case 'Requested':
            searchStatus = 1;
            $w('#searchOptions').value = ['Requested'];
            break;
        default:
            break;
        }
    });

    searchCases(user.ID, currentPage, key, searchStatus, initcase, pickedLabel, pickedLawyerID).then(response => {
        if (response) {
            console.log('All Cases: ', response);
            $w('#casesRepeater').data = [];
            if (!response.error){
                $w('#casesRepeater').data = response;
            }
            $w('#pagination').totalPages = Math.ceil(Number(response[0].Total) / 8);
            console.log(response[0].Total);
        }
    }).catch(error => console.log(error.message));
}

export function chooseLawyer_change(event) {
     pickedLawyerID = Number(event.target.value);
      searchCases(user.ID, currentPage, key, searchStatus, initcase, pickedLabel, pickedLawyerID).then(response => {
        if (response) {
            console.log('All Cases: ', response);
            $w('#casesRepeater').data = [];
            if (!response.error){
                $w('#casesRepeater').data = response;
            }
            $w('#pagination').totalPages = Math.ceil(Number(response[0].Total) / 8);
            console.log(response[0].Total);
        }
    }).catch(error => console.log(error.message));
    console.log('picked lawyerID: ',pickedLawyerID);
}

export function chooseLabel_change(event) {
     pickedLabel.push(Number(event.target.value));

     searchCases(user.ID, currentPage, key, searchStatus, initcase, pickedLabel, pickedLawyerID).then(response => {
        if (response) {
            console.log('All Cases: ', response);
            $w('#casesRepeater').data = [];
            if (!response.error){
                $w('#casesRepeater').data = response;
            }
            $w('#pagination').totalPages = Math.ceil(Number(response[0].Total) / 8);
            console.log(response[0].Total);
        }
    }).catch(error => console.log(error.message));
    console.log('picked label: ', pickedLabel);
}

export function keywordSearch_click(event) {
    key = event.target.parent.children[0].value;
    console.log('text: ', key);

   searchCases(user.ID, currentPage, key, searchStatus, initcase, pickedLabel, pickedLawyerID).then(response => {
        if (response) {
            console.log('All Cases: ', response);
            $w('#casesRepeater').data = [];
            if (!response.error){
                $w('#casesRepeater').data = response;
            }
            $w('#pagination').totalPages = Math.ceil(Number(response[0].Total) / 8);
            console.log(response[0].Total);
        }
    }).catch(error => console.log(error.message));
}

export function clearSearch_click(event) {
    $w('#name').value = '';
    $w('#chooseLabel').value = '';
    $w('#chooseLawyer').value = '';
    $w('#searchOptions').value = [];

    searchStatus = 0;
    initcase = 0;
    key = '';
    pickedLawyerID = 0;
    pickedLabel = [];
    
    $w('#casesRepeater').data = [];

   loadCases(Number(user.ID), currentPage).then(response => {
        console.log('loadCases', response);
        $w('#casesRepeater').data = response;
        $w('#pagination').totalPages = Math.ceil(Number(response[0].Total) / 8);
    }).catch(error => console.log(error));
}

export function finishCaseBtn_click(event) {
	$w('#finishCaseBox').expand();
}

export function sendFinishedCase_click(event) {
	let text = $w('#finishCaseText').value;
    let id = Number($w('#currentCaseID').text);

    finishCase(text, id).then(response => {

    }).catch(error => console.log(error));

    $w('#finishCaseText').value = '';
    $w('#finishCaseBox').collapse();

    getAllCases(user.ID);
}